'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { isSystemCharacter } from '@/contexts/characters/utils/systemCharacter';

export async function deleteCharacter(characterId: string): Promise<ActionResult<void>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    // Shared, admin-managed defaults (owl/cat …) can't be deleted by a family —
    // API-level guard, not just a hidden button. The admin console owns them.
    if (isSystemCharacter(characterId)) {
      return { success: false, error: 'System characters cannot be deleted' };
    }

    const { CharacterService } = await import('@/contexts/characters/services/CharacterService');
    await CharacterService.deleteCharacter({ characterId, familyId });

    return { success: true, data: undefined };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('deleteCharacter', e) };
  }
}
